// Attribution: https://github.com/Azure-Samples/ms-identity-javascript-react-tutorial 

// Dependencies
import React from 'react';

// Components
import { Notifications } from './Notifications';
import { Navigation } from './Navigation';
import { StickyFooter } from './StickyFooter';

const PageLayout = ({ children }) => (
    <>
        <Notifications />
        <Navigation>{children}</Navigation>
        <StickyFooter />
    </>
);

export { PageLayout };
